import BlockMeter from '../BlockMeter/BlockMeter';
import Scope from '../Scope/Scope';
import styles from './LamellaArea.module.css';

export default function LamellaArea({ envelope0, envelope1 }) {
    return (
        <div className={styles.container}>
            <div className={styles.meters}>
                <BlockMeter value={envelope0} orientation="vertical" numBlocks={20} fillHeight />
                <BlockMeter value={envelope1} orientation="vertical" numBlocks={20} fillHeight />
            </div>
            <div className={styles.scopeWrapper}>
                <Scope envelope0={envelope0} envelope1={envelope1} />
            </div>
        </div>
    );
}
